import { RouterProvider } from 'react-router-dom';
import { AppProviders } from './app/providers';
import { router } from './app/router';
import { debugLogger } from '@/shared/utils/debugLogger';
import { DebugPanel } from '@/shared/components/DebugPanel';

export const App = () => {
  // 初始化时打印历史日志
  if (debugLogger.getLogs().length > 0) {
    console.log('📋 发现历史调试日志，使用 debugLogger.print() 查看');
  }

  return (
    <AppProviders>
      <RouterProvider router={router} future={{ v7_startTransition: true }} />
      <DebugPanel />
    </AppProviders>
  );
};
